
<template>
   <v-dialog
      v-model="showTestDialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">This is the Test Dialog</v-card-title>

        <v-card-text>
          This shows/hides based on state variable.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="setShowTestDialog(false)"
          >
            Disagree
          </v-btn>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="setShowTestDialog(false)"
          >
            Agree
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>

<script>
import Vuex from 'vuex'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'TestDialog',

  data () {
    return {
    }
  },

  computed: {
    ...mapState({
                showTestDialog: state => state.ui.showTestDialog,
            }),

  },
  
  methods : {
    ...mapMutations(['setShowTestDialog',]),

    clickHandler : function () {
      console.log("Clicked")
    }
  },
}

</script>


<style>

</style>



// WEBPACK FOOTER //
// src/components/TestDialog.vue